import { render, staticRenderFns } from "./TranslationsCardCreate.vue?vue&type=template&id=46437984"
import script from "./TranslationsCardCreate.vue?vue&type=script&lang=js"
export * from "./TranslationsCardCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports